import { render, staticRenderFns } from "./StartLayout.vue?vue&type=template&id=983a0b86&"
import script from "./StartLayout.vue?vue&type=script&lang=js&"
export * from "./StartLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('983a0b86')) {
      api.createRecord('983a0b86', component.options)
    } else {
      api.reload('983a0b86', component.options)
    }
    module.hot.accept("./StartLayout.vue?vue&type=template&id=983a0b86&", function () {
      api.rerender('983a0b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/StartLayout.vue"
export default component.exports